import KunLoading18 from './src/index'

KunLoading18.install = function (Vue) {
	Vue.component(KunLoading18.name, KunLoading18);
}

export default KunLoading18;
